"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Layouts = require("layouts");
var Snippets = require("snippets");
var Sections = require("sections");
var reactive_click_and_collect_1 = require("@dotdev/reactive-click-and-collect");
var ProductTemplate = /** @class */ (function (_super) {
    __extends(ProductTemplate, _super);
    function ProductTemplate(props) {
        var _this = _super.call(this, props) || this;
        _this.sliderActive = React.createRef();
        _this.componentDidMount = function () {
            var _a = _this.props.data, section = _a.section, template = _a.template;
            var _b = _this.state, product = _b.product, variant = _b.variant;
            // const { blocks, settings } = section.product;
            var defaultVariant = product && product.variants && product.variants.length ? product.variants[0] : null;
            var images = product.images ? product.images.filter(function (image) { return !image.src.match(/_S[_\.]/i); }) : [];
            var ratio = "1:1";
            var ratioThumbnails = product.images && product.images.filter(function (image) { return image.aspect_ratio < 1; }).length ? "8:11" : "1:1";
            var video = product.metafields && product.metafields.ap21 && product.metafields.ap21.product_video ? product.metafields.ap21.product_video : null;
            var thumbnails = 6;
            var slider = {
                main: {
                    adaptiveHeight: false,
                    arrows: false,
                    autoplay: false,
                    dots: true,
                    draggable: false,
                    infinite: false,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    speed: 300,
                    appendDots: function (dots) { return (React.createElement("div", null,
                        React.createElement("div", { className: "slick-dots absolute pin-b pin-x flex justify-center max-w-1/2 mx-auto", style: { bottom: "16px" } },
                            React.createElement("ul", { className: "text-center list-reset flex flex-row" }, dots)))); },
                    customPaging: function (i) { return (React.createElement("button", { className: "md:hidden block rounded-full bg-secondary-blue-grey border border-transparent outline-none focus:outline-none p-0-3 transition" })); },
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                dots: true,
                                infinite: true
                            }
                        }
                    ],
                    beforeChange: function (current, next) { return (_this.sliderActive.current ? (_this.sliderActive.current.style.transform = "translateX(" + next * 100 + "%)") : null,
                        _this.selectImage(next)); }
                },
                thumbnails: {
                    adaptiveHeight: false,
                    arrows: true,
                    autoplay: false,
                    dots: false,
                    draggable: false,
                    infinite: false,
                    slidesToScroll: 1,
                    slidesToShow: thumbnails,
                    speed: 300,
                    vertical: true,
                    beforeChange: function (current, next) { return _this.selectImage(next); },
                    prevArrow: (React.createElement("button", null,
                        React.createElement("div", { className: "flex items-center justify-center w-full p-0-3 text-midnight transition-fast bg-arctic-smoke" },
                            React.createElement(Snippets.Svg, { name: "chevron-up", width: 24 })))),
                    nextArrow: (React.createElement("button", null,
                        React.createElement("div", { className: "flex items-center justify-center w-full p-0-3 text-midnight transition-fast bg-arctic-smoke" },
                            React.createElement(Snippets.Svg, { name: "chevron-down", width: 24 }))))
                }
            };
            var media = {
                images: images,
                ratio: ratio,
                ratioThumbnails: ratioThumbnails,
                slider: slider,
                thumbnails: thumbnails,
                video: video
            };
            var customGuernsey = _this.props.data.product.tags && _this.props.data.product.tags.filter(function (tag) { return tag.toLowerCase().includes("customisable:true"); }).length > 0;
            var customJumper = !customGuernsey && _this.props.data.product.tags && _this.props.data.product.tags.filter(function (tag) { return tag.toLowerCase().includes("customisablejumper:true"); }).length > 0;
            var customizable = false;
            var prodSettings = section.product.settings;
            if (customGuernsey) {
                if (prodSettings.one_num_price && prodSettings.two_num_price && prodSettings.one_num_variant_id && prodSettings.two_num_variant_id) {
                    _this.setState({ customizedHandle: "guernsey" });
                    customizable = true;
                }
            }
            if (customJumper) {
                if (prodSettings.jumper_one_num_price && prodSettings.jumper_two_num_price && prodSettings.jumper_one_num_variant_id && prodSettings.jumper_two_num_variant_id) {
                    _this.setState({ customizedHandle: "jumper" });
                    customizable = true;
                }
            }
            _this.setState({
                media: media,
                variant: variant,
                preorder: _this.checkPreorder(variant),
                customizable: customizable
            });
            next_components_1.ShopifyNext.Cart.getProductRecommendations(product.id, 12);
            if (_this.state.cncEnabled) {
                _this.getStore(_this.props.data.shop.cart);
            }
        };
        _this.API_URL = _this.props.data.shop.permanent_domain == "the-afl-store-au-stage.myshopify.com"
            ? "https://connector-stage.theaflstore.io"
            : "https://connector.theaflstore.io";
        _this.clickAndCollect = new reactive_click_and_collect_1.ClickAndCollect({
            endpoint: {
                locations: _this.API_URL + "/api/locations",
                stock: _this.API_URL + "/api/stock"
            },
            googleMapsApiVersion: "3.37",
            googleMapsApiKey: "AIzaSyC2pbhg5eMUosOwcUVcn0RWuYaqbdGMXmc"
        });
        _this.toggleCCModal = function () {
            next_components_1.ShopifyNext.Cart.getCart();
            _this.setState({
                showCCModal: !_this.state.showCCModal
            });
        };
        _this.updateStore = function (newStore, newId) {
            _this.setState({
                cncStore: newStore,
                cncId: newId,
                cncAvailable: true
            });
        };
        _this.getStore = function (cart) { return __awaiter(_this, void 0, void 0, function () {
            var response, stock;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(cart && cart.attributes && cart.attributes.pickup_store_name && cart.attributes.pickup_store_id)) return [3 /*break*/, 3];
                        return [4 /*yield*/, fetch(this.clickAndCollect.options.endpoint.stock, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    location: cart.attributes.pickup_store_id,
                                    items: [this.state.variant.sku]
                                })
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        stock = _a.sent();
                        if (stock &&
                            stock.items &&
                            stock.items[this.state.variant.sku] &&
                            Number.parseInt(stock.items[this.state.variant.sku]) &&
                            stock.location) {
                            this.setState({
                                cncStore: cart.attributes.pickup_store_name,
                                cncId: cart.attributes.pickup_store_id,
                                cncAvailable: true
                            });
                        }
                        else {
                            this.setState({
                                cncStore: cart.attributes.pickup_store_name,
                                cncId: cart.attributes.pickup_store_id,
                                cncAvailable: false
                            });
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.setCustomOptions = function (key, newOption) {
            _this.setState({
                customOptionKey: key,
                customOptionValue: newOption,
                customOptionError: false
            });
        };
        _this.handleQtyChange = function (type) {
            var _a, _b, _c, _d, _e, _f;
            var _g = _this.state, quantity = _g.quantity, variant = _g.variant, product = _g.product;
            var newQuantity = quantity;
            var preorder = (_c = (_b = (_a = product) === null || _a === void 0 ? void 0 : _a.preorderme) === null || _b === void 0 ? void 0 : _b.product_settings) === null || _c === void 0 ? void 0 : _c[(_d = product) === null || _d === void 0 ? void 0 : _d.selected_or_first_available_variant];
            var maxNumber = ((_f = (_e = preorder) === null || _e === void 0 ? void 0 : _e[variant.id]) === null || _f === void 0 ? void 0 : _f.qty) || variant.inventory_quantity;
            type == "+" && (quantity + 1 <= maxNumber || _this.checkPreorder(variant)) ? (newQuantity += 1) : null;
            type == "-" && quantity > 1 ? (newQuantity -= 1) : null;
            quantity !== newQuantity ? _this.setState({ quantity: newQuantity }) : null;
        };
        _this.handleAddToCart = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var data, _a, customOptionKey, customOptionValue, preorder, customizedNumber, cncStore, quantity, customizedHandle, customizable, customOptionError, cartProps, hasCustomOptKeyAndValue, validProp, cartPropsToAdd, customVariantIds, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        event.preventDefault();
                        data = this.props.data;
                        _a = this.state, customOptionKey = _a.customOptionKey, customOptionValue = _a.customOptionValue, preorder = _a.preorder, customizedNumber = _a.customizedNumber, cncStore = _a.cncStore, quantity = _a.quantity, customizedHandle = _a.customizedHandle, customizable = _a.customizable;
                        customOptionError = !(!customOptionKey || (customOptionKey && customOptionValue));
                        if (customOptionError) {
                            return [2 /*return*/, this.setState({ customOptionError: true })];
                        }
                        cartProps = { properties: {} };
                        hasCustomOptKeyAndValue = customOptionKey && customOptionValue;
                        validProp = false;
                        if (hasCustomOptKeyAndValue || preorder || customizedNumber || cncStore) {
                            validProp = true;
                        }
                        if (hasCustomOptKeyAndValue) {
                            cartProps.properties["custom_" + customOptionKey] = customOptionValue;
                        }
                        if (preorder) {
                            cartProps.properties.preorder = true;
                        }
                        if (customizedNumber) {
                            cartProps.properties.gift_wrap_numbers = customizedNumber;
                        }
                        if (cncStore) {
                            // eslint-disable-next-line no-underscore-dangle
                            cartProps.properties._click_and_collect = true;
                        }
                        cartPropsToAdd = validProp ? cartProps : null;
                        return [4 /*yield*/, next_components_1.ShopifyNext.Cart.addItem(parseInt(event.target.id, 10), quantity, cartPropsToAdd)];
                    case 1:
                        _c.sent();
                        customVariantIds = customizable && customizedHandle === 'jumper' ? [data.section.product.settings.jumper_one_num_variant_id, data.section.product.settings.jumper_two_num_variant_id] : [data.section.product.settings.one_num_variant_id, data.section.product.settings.two_num_variant_id];
                        _b = this.state.customizable &&
                            this.state.customizedNumber &&
                            (this.state.customizedNumber.length === 1 || this.state.customizedNumber.length === 2);
                        if (!_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, next_components_1.ShopifyNext.Cart.addItem(parseInt(this.state.customizedNumber.length === 1 ? customVariantIds[0] : customVariantIds[1], 10), 1)];
                    case 2:
                        _b = (_c.sent());
                        _c.label = 3;
                    case 3: return [2 /*return*/, (_b)];
                }
            });
        }); };
        _this.handleChange = function (value, index) {
            var _a;
            var selectedOptions = __assign(__assign({}, _this.state.selectedOptions), (_a = {}, _a["option" + index] = value.title ? value.title : value, _a));
            var selectedVariant = _this.findVariant(selectedOptions, _this.state.product.variants);
            if (!selectedVariant && value.value == "Colour") {
                selectedVariant = _this.state.product.variants.find(function (v) { return v.option2 === selectedOptions.option2; });
            }
            else if (!selectedVariant) {
                return;
            }
            _this.setState(__assign(__assign({}, _this.state), { variant: selectedVariant, selected: selectedVariant, preorder: _this.checkPreorder(selectedVariant), selectedOptions: selectedOptions, quantity: 1, backToStockIsActive: false }));
            if (!selectedVariant)
                return;
            if (window.innerWidth > 768) {
                _this.props.history.push("?variant=" + selectedVariant.id);
            }
            setTimeout(function () {
                var _a, _b, _c;
                (_c = (_a = window) === null || _a === void 0 ? void 0 : (_b = _a).PreOrderMeBtn) === null || _c === void 0 ? void 0 : _c.call(_b);
            }, 300);
        };
        _this.checkPreorder = function (variant) {
            var _a, _b, _c, _d, _e;
            if (!variant)
                return false;
            var match = false;
            if (((_c = (_b = (_a = _this.state.product.preorderme) === null || _a === void 0 ? void 0 : _a.product_settings) === null || _b === void 0 ? void 0 : _b[variant.id]) === null || _c === void 0 ? void 0 : _c.enabled) && ((_d = variant) === null || _d === void 0 ? void 0 : _d.inventory_quantity) < 1) {
                match = true;
            }
            return ((variant.inventory_quantity < 1 && variant.inventory_policy === "continue" && ((_e = _this.props.data.template) === null || _e === void 0 ? void 0 : _e.suffix) !== "gift-card") ||
                match);
        };
        _this.getVariant = function (id, variants) { return variants.filter(function (v) { return v.id === id; })[0]; };
        _this.findVariant = function (selected, variants) {
            var variant = variants.filter(function (v) { return v.option1 === selected.option1 && v.option2 === selected.option2 && v.option3 === selected.option3; });
            return variant ? variant[0] : null;
        };
        _this.findOption = function (id, index) {
            var variant = _this.state.product.variants.filter(function (v) { return v.id === id; });
            return variant[0]["option" + (index + 1)];
        };
        _this.findOptions = function (id, variants) {
            var variant = variants.filter(function (v) { return v.id === id; });
            return {
                option1: variant[0].option1,
                option2: variant[0].option2,
                option3: variant[0].option3
            };
        };
        _this.toggleZoom = function () {
            _this.setState({ zoomed: !_this.state.zoomed });
        };
        _this.selectImage = function (index) {
            _this.state.currentSlide !== index
                ? _this.setState({
                    currentSlide: index
                })
                : null;
        };
        _this.toggleSizeGuide = function () {
            event.preventDefault();
            _this.state.showSizeGuide
                ? _this.props.history.push("" + window.location.pathname)
                : _this.props.history.push(window.location.pathname + "#sizing");
            _this.setState({ showSizeGuide: !_this.state.showSizeGuide });
        };
        _this.toggleBackToStockNotification = function () {
            _this.setState(function (prevState) { return ({
                backToStockIsActive: !prevState.backToStockIsActive
            }); });
        };
        _this.toggleCustomizeForm = function () {
            _this.setState(function (prevState) { return ({
                isCustomizeFormActive: !prevState.isCustomizeFormActive
            }); });
        };
        _this.handleCustomizedNumber = function (number) {
            _this.setState({
                customizedNumber: number
            });
        };
        _this.handleGiftCardChange = function (event) {
            var giftCardProperties = _this.state.giftCardProperties;
            giftCardProperties[event.target.name] = event.target.value.replace(/(?:\r\n|\r|\n)/g, "<br />");
            _this.setState({ giftCardProperties: giftCardProperties });
        };
        _this.handleGiftCardAddToCart = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        event.preventDefault();
                        if (!(this.state.giftCardProperties &&
                            this.state.giftCardProperties.email &&
                            this.state.giftCardProperties.name &&
                            this.state.giftCardProperties.message)) return [3 /*break*/, 4];
                        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.giftCardProperties.email)) return [3 /*break*/, 2];
                        this.setState({
                            giftCardErrors: null
                        });
                        return [4 /*yield*/, next_components_1.ShopifyNext.Cart.addItem(parseInt(event.target.id, 10), this.state.quantity, {
                                properties: {
                                    Recipient: this.state.giftCardProperties.name,
                                    Message: this.state.giftCardProperties.message,
                                    "Recipient Email": this.state.giftCardProperties.email
                                }
                            })];
                    case 1:
                        _b = (_c.sent());
                        return [3 /*break*/, 3];
                    case 2:
                        _b = this.setState({
                            giftCardErrors: "Please enter a valid email address"
                        });
                        _c.label = 3;
                    case 3:
                        _a = _b;
                        return [3 /*break*/, 5];
                    case 4:
                        _a = this.setState({
                            giftCardErrors: "Please fill out all fields"
                        });
                        _c.label = 5;
                    case 5:
                        _a;
                        return [2 /*return*/];
                }
            });
        }); };
        var _a = _this.props.data, product = _a.product, template = _a.template;
        var selectedOptions = _this.findOptions(product.selected_or_first_available_variant, product.variants);
        var variant = _this.getVariant(product.selected_or_first_available_variant, product.variants);
        var selected = product.selected_variant
            ? _this.getVariant(product.selected_variant, product.variants)
            : product.variants.length === 1
                ? product.selected_or_first_available_variant
                : template && template.suffix === "gift-card"
                    ? product.first_available_variant
                    : null;
        var enabledOptions = product.variants.filter(function (v) { return v.available === true; }).map(function (v) { return v.title; });
        var onSaleOptions = product.variants.filter(function (v) { return v.compare_at_price > v.price; }).map(function (v) { return v.title; });
        var sizeGuide = product.images ? product.images.filter(function (image) { return image.src.match(/_S[_\.]/i); }) : [];
        _this.state = {
            product: product,
            variant: variant,
            selected: selected,
            options: product.options,
            preorder: null,
            quantity: 1,
            selectedOptions: selectedOptions,
            enabledOptions: enabledOptions,
            onSaleOptions: onSaleOptions,
            currentSlide: 0,
            zoomed: false,
            video: false,
            videoActive: false,
            brandVideo: false,
            brandVideoActive: false,
            sizeGuide: sizeGuide,
            showSizeGuide: false,
            backToStockIsActive: false,
            customizable: false,
            customizedNumber: null,
            customizedHandle: null,
            isCustomizeFormActive: false,
            giftCardErrors: null,
            giftCardProperties: {},
            cncStore: false,
            cncId: false,
            cncAvailable: false,
            showCCModal: false,
            cncEnabled: _this.props.data.settings.click_and_collect_enabled,
            customOptionKey: product.metafields && product.metafields.customProductForm && product.metafields.customProductForm.key
                ? product.metafields.customProductForm.key
                : null,
            customOptionValue: "",
            customOptionError: false,
            featuredVideoContent: product.metafields && product.metafields.featuredVideo ? product.metafields.featuredVideo : null
        };
        _this.toggleZoom = _this.toggleZoom.bind(_this);
        _this.selectImage = _this.selectImage.bind(_this);
        return _this;
    }
    ProductTemplate.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props.data, template = _b.template, section = _b.section;
        var _c = this.state, media = _c.media, product = _c.product, variant = _c.variant;
        var daRestock = this.props.data.shop.metafields["da-restock"];
        var optionsLowerCase = [];
        if (product.options) {
            product.options.map(function (option) { return optionsLowerCase.push(option.toLowerCase()); });
        }
        var colourIndex = optionsLowerCase.includes("colour")
            ? optionsLowerCase.indexOf("colour")
            : optionsLowerCase.includes("color")
                ? optionsLowerCase.indexOf("color")
                : null;
        var sizeIndex = optionsLowerCase.includes("size") ? optionsLowerCase.indexOf("size") : null;
        var grouped = product.grouped.filter(function (product) { return product.id; });
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement("div", { className: "relative bg-very-light-pink" },
                React.createElement("div", { className: "hidden md:block bg-arctic absolute pin-l h-full w-gold-reverse" }),
                React.createElement(Snippets.Container, { tag: "section", width: "xl", className: "pl-1-6 md:px-11 transform-x absolute flex-col md:flex-row items-center py-0-9 md:pt-2-2 md:pb-2-4 bg-arctic md:bg-transparent" },
                    React.createElement("div", { className: "w-full md:w-1/2" },
                        React.createElement(Snippets.Breadcrumbs, __assign({}, this.props))),
                    React.createElement("div", { className: "hidden md:block w-1/2" })),
                React.createElement(Snippets.Container, { tag: "section", width: "xl", className: "px-1-6 md:px-11 pb-0-8 md:pb-5-5 pt-3-2 md:pt-6-1" },
                    React.createElement("div", { className: "block md:flex" },
                        React.createElement("div", { className: "w-full md:w-1/2 lg:w-7/12 lg:pr-1-6" }, media ? (React.createElement(Snippets.ProductSlider, __assign({}, this.props, { className: "-mx-1-6 md:mx-0", active: this.state.currentSlide, navigation: media.images.length, thumbnails: media.thumbnails, ratio: media.ratio, ratioThumbnails: media.ratioThumbnails, selectImage: this.selectImage, settings: media.slider, images: media.images, tags: product.tags, toggleZoom: this.toggleZoom, zoomed: this.state.zoomed, video: media.video }))) : null),
                        React.createElement("div", { className: "bg-very-light-pink w-full md:w-1/2 mt-1-6 md:mt-0 lg:w-5/12 md:pl-5-3 lg:pl-6-2 md:pr-2-2" },
                            template && template.suffix === "gift-card" && ((_a = product.product_type) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "gift card" ? (React.createElement(React.Fragment, null,
                                React.createElement(next_components_1.ShopifyNext.Components.Forms, { data: this.props.data.form.product, className: "block" },
                                    React.createElement("select", { name: "id", className: "hidden", defaultValue: variant.id },
                                        React.createElement("option", { value: variant.id }, variant.id)),
                                    React.createElement(Snippets.Heading, { size: "h1", tag: "h1", className: "text-xmd md:text-36 font-semibold md:font-bold leading-none mb-0-8 md:mb-1-6" }, product.title),
                                    React.createElement("div", { className: "flex items-center justify-between mb-0-6 md:mb-1-6 font-semibold text-xmd" },
                                        React.createElement(Snippets.ProductPrice, __assign({}, this.props, { variant: variant, layout: "product", showDiscount: true, showCurrency: false, showUnavailable: true, isPreorder: this.state.preorder, moneyFormat: this.props.data.shop.money_format, moneyFormatCurrency: this.props.data.shop.money_with_currency_format }))),
                                    !product.has_only_default_variant ? (React.createElement(Snippets.ProductOptions, __assign({}, this.props, { className: "mb-2-4 mb:mb-3-6", options: product.options_with_values, config: {
                                            value: {
                                                layout: "list"
                                            },
                                            type: {
                                                layout: "list"
                                            }
                                        }, variant: variant, selected: this.state.selected, selectedOptions: this.state.selectedOptions, enabledOptions: this.state.enabledOptions, onSaleOptions: this.state.onSaleOptions, showTitles: false, isPreorder: this.state.preorder, onChange: function (value, index) { return _this.handleChange(value, index); } }))) : null,
                                    this.state.variant.option2.toLowerCase().includes("digital") && (React.createElement("div", { className: "mb-1-2" },
                                        React.createElement(Snippets.Heading, { size: "h1", tag: "h5", className: "text-base mb-2-4" }, "Who's receiving this gift voucher?"),
                                        React.createElement(Snippets.Input, { type: "text", style: "large", className: "w-full mb-0-9", placeholder: "Send to (email address)", name: "email", onChange: function (event) { return _this.handleGiftCardChange(event); } }),
                                        React.createElement(Snippets.FormErrors, { errors: "Send the voucher to yourself to print or direct to the recipient's inbox", className: "mb-0-9 text-charcoal" }),
                                        React.createElement(Snippets.Input, { type: "text", style: "large", className: "w-full mb-1-7", placeholder: "Recipient's name", name: "name", maxLength: 50, onChange: function (event) { return _this.handleGiftCardChange(event); } }),
                                        React.createElement(Snippets.Input, { type: "textarea", className: "w-full", placeholder: "Message", name: "message", onChange: function (event) { return _this.handleGiftCardChange(event); } }),
                                        React.createElement(Snippets.FormErrors, { errors: this.state.giftCardErrors, className: "mt-0-9" }),
                                        React.createElement(Snippets.ProductAddToCart, { className: "w-full rounded border-navy-dark", variant: variant, handleAddToCart: this.handleGiftCardAddToCart, text: this.state.selected
                                                ? this.state.preorder
                                                    ? this.props.data.locales.global.cart.preorder
                                                    : variant.available
                                                        ? this.props.data.locales.global.cart.add
                                                        : this.props.data.locales.global.cart.sold_out
                                                : sizeIndex
                                                    ? this.props.data.locales.product.select_option + " " + product.options[sizeIndex]
                                                    : sizeIndex == null
                                                        ? this.props.data.locales.global.cart.add
                                                        : this.props.data.locales.product.select_variant, disabled: !(this.state.giftCardProperties &&
                                                this.state.giftCardProperties.email &&
                                                this.state.giftCardProperties.name &&
                                                this.state.giftCardProperties.message) }))),
                                    this.state.variant.option2.toLowerCase().includes("physical") && (React.createElement("div", { className: "flex flex-row mb-1-6 w-full" },
                                        variant.available && (React.createElement(Snippets.ProductItemQty, __assign({}, this.props, { handleQtyChange: this.handleQtyChange, max: this.state.variant.inventory_quantity, quantity: this.state.quantity, className: "w-5/12 sm:w-1/3 h-6 bg-navy rounded-l border-r-1 border-nvay-dark px-0-6", isPreorder: this.state.preorder }))),
                                        React.createElement(Snippets.ProductAddToCart, { className: (variant.available ? "w-7/12 md:w-2/3 rounded-r border-l" : "w-full rounded") + "  border-navy-dark", variant: variant, handleAddToCart: this.handleAddToCart, text: this.state.selected
                                                ? this.state.preorder
                                                    ? this.props.data.locales.global.cart.preorder
                                                    : variant.available
                                                        ? this.props.data.locales.global.cart.add
                                                        : this.props.data.locales.global.cart.sold_out
                                                : sizeIndex
                                                    ? this.props.data.locales.product.select_option + " " + product.options[sizeIndex]
                                                    : sizeIndex == null
                                                        ? this.props.data.locales.global.cart.add
                                                        : this.props.data.locales.product.select_variant, disabled: !variant.available || !this.state.selected }))),
                                    !this.state.backToStockIsActive && (React.createElement(Snippets.ProductStockInfo, __assign({}, this.props, { selected: this.state.selected, variant: this.state.variant, product: this.props.data.product, isPreorder: this.state.preorder, toggleBackToStockNotification: this.toggleBackToStockNotification })))))) : (React.createElement(React.Fragment, null,
                                React.createElement(next_components_1.ShopifyNext.Components.Forms, { data: this.props.data.form.product, className: "block" },
                                    React.createElement("select", { name: "id", className: "hidden", defaultValue: variant.id },
                                        React.createElement("option", { value: variant.id }, variant.id)),
                                    React.createElement(Snippets.Heading, { size: "h1", tag: "h1", className: "text-xmd md:text-36 font-semibold md:font-bold leading-none mb-0-8 md:mb-1-6" }, product.title),
                                    React.createElement("div", { className: "flex items-center justify-between mb-0-2 md:mb-0-6 font-semibold text-xmd" },
                                        React.createElement(Snippets.ProductPrice, __assign({}, this.props, { variant: variant, layout: "product", showDiscount: true, showCurrency: false, showUnavailable: true, isPreorder: this.state.preorder, moneyFormat: this.props.data.shop.money_format, moneyFormatCurrency: this.props.data.shop.money_with_currency_format }))),
                                    variant && variant.available ? (React.createElement(Snippets.AfterPay, { className: "flex flex-row mb-2-5 text-charcoal text-xs", price: variant.price, format: this.props.data.shop.money_with_currency_format })) : (React.createElement(Snippets.AfterPay, { className: "flex flex-row mb-2-5 text-charcoal text-xs", price: product.price, format: this.props.data.shop.money_with_currency_format })),
                                    this.state.customizable && (React.createElement(Snippets.ProductCustomize, { section: this.props.data.section, product: product, handle: this.state.customizedHandle, toggleCustomizeForm: this.toggleCustomizeForm, isCustomizeFormActive: this.state.isCustomizeFormActive, handleCustomizedNumber: this.handleCustomizedNumber, moneyFormat: this.props.data.shop.money_format })),
                                    grouped && grouped.length != -1 ? (React.createElement(Snippets.ProductGroups, { variant: variant, optionIndex: colourIndex, title: "Color", products: grouped, product: product })) : null,
                                    !product.has_only_default_variant ? (React.createElement(Snippets.ProductOptions, __assign({}, this.props, { className: "mb-2-4 mb:mb-3-6", options: product.options_with_values, config: {
                                            size: {
                                                layout: "grid",
                                                linkText: this.state.sizeGuide.length > 0 ? this.props.data.locales.product.size_guide : null,
                                                click: this.state.sizeGuide.length > 0 ? this.toggleSizeGuide : null
                                            }
                                        }, variant: variant, selected: this.state.selected, selectedOptions: this.state.selectedOptions, enabledOptions: this.state.enabledOptions, onSaleOptions: this.state.onSaleOptions, showTitles: true, isPreorder: this.state.preorder, onChange: function (value, index) { return _this.handleChange(value, index); } }))) : null,
                                    product.metafields && product.metafields.customProductForm && product.metafields.customProductForm.values && (React.createElement(Snippets.ProductOptionsCustom, { title: product.metafields.customProductForm.title, fieldKey: product.metafields.customProductForm.key, values: product.metafields.customProductForm.values, setCustomOptions: this.setCustomOptions, selected: this.state.customOptionValue, showError: this.state.customOptionError })),
                                    React.createElement("div", { className: "flex flex-row mb-1-6 w-full flex-wrap" },
                                        variant.available && (React.createElement(Snippets.ProductItemQty, __assign({}, this.props, { handleQtyChange: this.handleQtyChange, max: this.state.variant.inventory_quantity, quantity: this.state.quantity, className: "w-5/12 sm:w-1/3 h-6 bg-navy rounded-l border-r-1 border-nvay-dark px-0-6", isPreorder: this.state.preorder }))),
                                        React.createElement(Snippets.ProductAddToCart, { className: (variant.available ? "w-7/12 md:w-2/3 rounded-r border-l" : "w-full rounded") + "  border-navy-dark", variant: variant, handleAddToCart: this.handleAddToCart, text: this.state.selected
                                                ? this.state.preorder
                                                    ? this.props.data.locales.global.cart.preorder
                                                    : variant.available
                                                        ? this.props.data.locales.global.cart.add
                                                        : this.props.data.locales.global.cart.sold_out
                                                : sizeIndex
                                                    ? this.props.data.locales.product.select_option + " " + product.options[sizeIndex]
                                                    : sizeIndex == null
                                                        ? this.props.data.locales.global.cart.add
                                                        : this.props.data.locales.product.select_variant, disabled: !variant.available || !this.state.selected })),
                                    !this.state.backToStockIsActive && (React.createElement(Snippets.ProductStockInfo, __assign({}, this.props, { selected: this.state.selected, variant: this.state.variant, product: this.props.data.product, isPreorder: this.state.preorder, toggleBackToStockNotification: this.toggleBackToStockNotification }))),
                                    React.createElement(Snippets.WishlistIcon, { className: "w-2-0 h-2-0 min-w-2-0 flex items-center justify-start text-black ml-0-4", customer: this.props.data.customer || {}, product: product, variant: variant, showText: true })),
                                this.state.cncEnabled ? (React.createElement("div", { className: "flex flex-row mb-1-6 w-full" },
                                    React.createElement(Snippets.ProductFindInStore, __assign({ className: "w-full rounded border-navy-dark", variant: variant, id: variant.id }, this.props, { text: this.state.cncStore ? "Change Store" : "Find in Store", show: this.state.showCCModal, toggle: this.toggleCCModal, updateStore: this.updateStore, available: this.state.cncAvailable, cncStore: this.state.cncStore })))) : null)),
                            !variant.available && this.state.backToStockIsActive && (React.createElement("div", { className: "mt-2-4", id: "" },
                                React.createElement("div", { id: "dd-restock-notification-msg" },
                                    React.createElement("div", { id: "dd-restock-notification-msg-success", className: "text-sm text-navy-dark font-semibold", style: { display: "none" } }, daRestock.success),
                                    React.createElement("div", { id: "dd-restock-notification-msg-error", className: "text-red text-sm font-semibold", style: { display: "none" } }, daRestock.error)),
                                React.createElement("div", { className: "da-restock-alwaysShow" }),
                                React.createElement("div", { className: "text-sm da-restock-notification", id: "da-restock-notification-variant-" + variant.id },
                                    React.createElement("div", { className: "flex flex-row items-center mb-1-6" },
                                        React.createElement(Snippets.Svg, { name: "bell", width: 20 }),
                                        React.createElement("span", { className: "ml-0-8 text-navy-dark text-sm font-semibold mt-0-2" }, "Notify me when it\u2019s back in stock")),
                                    React.createElement("div", { className: "uppercase text-xs font-semibold tracking-wideless mb-0-4" }, "Email"),
                                    React.createElement("form", { action: "https://alertmerestockalerts.herokuapp.com/addemail", method: "post", onSubmit: function (event) { return event.preventDefault; } },
                                        React.createElement("input", { type: "hidden", name: "store", value: this.props.data.shop.permanent_domain }),
                                        React.createElement("input", { type: "hidden", name: "product", value: this.state.product.id }),
                                        React.createElement("input", { type: "hidden", name: "url", value: this.state.product.url }),
                                        React.createElement("input", { type: "hidden", id: "da-restock-variant", name: "variant", value: variant.id }),
                                        React.createElement("input", { type: "email", name: "email", placeholder: daRestock.productInput, autoCapitalize: "no", autoCorrect: "no", required: true, autoFocus: true, className: "w-full rounded px-1-2 py-0 mb-2-4 h-4-8 border border-secondary-blue-grey text-navy-dark transition-fast focus:outline-none focus:shadow-none" }),
                                        React.createElement(Snippets.Button, { type: "submit", className: "block w-full rounded capitalize", style: "solid" }, daRestock.productButton))))))))),
            React.createElement("div", { className: "md:hidden bg-very-light-pink" },
                React.createElement("div", { className: "mx-1-6 border-t border-secondary-blue-grey pb-2-7 my-0" })),
            React.createElement(Snippets.Container, { tag: "section", width: "xl", className: "px-1-6 md:px-11 pb-3-7 md:pb-4-2 bg-very-light-pink sm:bg-arctic" },
                React.createElement(Snippets.ProductContent, __assign({}, this.props, { product: this.state.product, variant: this.state.variant, content: this.getTabContent(this.props.data.section.product.settings), videoContent: this.state.featuredVideoContent }))),
            React.createElement("div", { className: "bg-navy text-arctic md:pt-4-8 md:pb-2-2" },
                React.createElement(Snippets.Container, { tag: "section", width: "xl", className: "px-1-6 md:px-11 py-3-7 md:py-4-2 " },
                    React.createElement(Snippets.ProductBundle, { product: this.state.product, settings: this.props.data.section.product.settings }))),
            React.createElement("div", { className: "bg-very-light-pink md:pt-4-8 md:pb-2-2" },
                React.createElement(Snippets.Container, { tag: "section", width: "xl", className: "px-1-6 md:px-11 pb-0-2" },
                    React.createElement("span", { className: "text-xmd font-semibold text-navy" }, "People also looked at")),
                React.createElement(Sections.FeaturedProducts, __assign({}, this.props, { section: this.props.data.section.prods, simple: true }))),
            React.createElement("div", { className: "hidden md:block bg-very-light-pink pb-7-2" },
                React.createElement(Snippets.Container, { tag: "section", width: "xl", className: "px-1-6 md:px-11" },
                    React.createElement(Snippets.ProductRecommended, __assign({}, this.props, { section: this.props.data.section.prods, title: "Customers who bought these items also purchased", limit: 6, simple: true })))),
            React.createElement(Sections.CTA, __assign({}, this.props, { section: this.props.data.section.cta })),
            this.state.sizeGuide.length > 0 && (React.createElement("section", { className: "fixed flex md:items-center justify-center pin z-100 overflow-auto " + (this.state.showSizeGuide ? "transition visible" : "transition-fast invisible") },
                React.createElement("div", { className: "absolute pin bg-navy-dark " + (this.state.showSizeGuide ? "transition opacity-60" : "transition-fast opacity-0"), onClick: function () { return _this.toggleSizeGuide(); } }),
                React.createElement("div", { className: "relative w-full max-w-md bg-arctic text-dark " + (this.state.showSizeGuide
                        ? "transition transition-delay translate-y:0 visible opacity-100"
                        : "transition-fast transition-delay-none translate-y:20x invisible opacity-0") },
                    React.createElement("div", { className: "flex items-center justify-end pt-2-3 px-2-3" },
                        React.createElement("button", { type: "button", title: "Close", onClick: function () { return _this.toggleSizeGuide(); }, className: "z-10 text-primary hover:text-brand transition-fast cursor-pointer" },
                            React.createElement(Snippets.Svg, { name: "cross", width: 12 }))),
                    React.createElement("div", { className: "flex items-center justify-center" },
                        React.createElement("img", { src: this.state.sizeGuide[0].src, alt: this.state.sizeGuide[0].alt })))))));
    };
    ProductTemplate.prototype.getTabContent = function (section) {
        var result = section;
        var deliveryReturn = this.props.data.product.metafields.deliveryReturns ? this.props.data.product.metafields.deliveryReturns : null;
        if (deliveryReturn && deliveryReturn.length > 10) {
            result.delivery_returns = deliveryReturn;
        }
        return result;
    };
    ProductTemplate.contextType = next_components_1.ShopifyNext.Context;
    return ProductTemplate;
}(React.Component));
exports.ProductTemplate = ProductTemplate;
